import React from "react"
import icon from "images/layout/chevron-down.svg"

export default function ChevronDownIcon() {
  return (
    <span className="svg-icon" dangerouslySetInnerHTML={{ __html: icon }} />
  )
}
